import {
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { debounce } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import { ReactComponent as About } from "../../image/About.svg";
import { ReactComponent as CircleIcon } from "../../image/CircleIcon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { ReactComponent as Email } from "../../image/Email.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Vector } from "../../image/Vector.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const RequestedFollowUpModal = ({
  handleRefresh,
  requesteddemoId,
  setStateList,
  stateList,
  setRequestedDemoId,
  handleCancel,
  form,
  setReload,
  reload,
  modalKey,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  dayjs.extend(customParseFormat);

  const formRefFollowUp = useRef();

  // state initialisation
  const initialState = {
    name: "",
    company: "",
    phone_number: "91",
    email: "",
    no_of_buyer: "",
    demo_date: null,
    request_date: dayjs().format("DD-MM-YYYY HH:mm"),
    about_company: "",
    remark: "",
    demo_type: "Online",
  };
  const initialDocument = {
    request_demo: requesteddemoId,
    follow_up_date: null,
    follow_up_note: null,
  };
  const { Panel } = Collapse;
  const [state, setState] = useState(initialState);
  const [documentState, setDocumentState] = useState(initialDocument);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingAdd, setBtnLoadingAdd] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [companyDocumentList, setCompanyDocumentList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [addedCompanyId, setAddedCompanyId] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [companyDocumentId, setCompanyDocumentId] = useState(null);
  const [apiloading, setapiLoading] = useState(false);
  const [apiloadingFollow, setapiloadingFollow] = useState(false);
  const [btnDisplay, setBtnDisplay] = useState("Add");
  const [followUpCompanyName, setFollowUpCompanyName] = useState(null);

  const [stateDocumentTable, setStateDocumentTable] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const { Search } = Input;
  const colors = ["#094E8F"];

  // Fetch Company Documenet
  useEffect(() => {
    const getCompanyDocument = async () => {
      // setapiloadingFollow(true);
      setapiloadingFollow(true);
      try {
        const apiResponse = await getRequest(
          `request-for-demo-follow-up/${companyDocumentId}`
        );
        if (apiResponse.data.success) {
          const follow_up_date = apiResponse.data.data.follow_up_date
            ? moment(apiResponse.data.data.follow_up_date, "DD-MM-YYYY HH:mm")
            : null;

          setDocumentState({
            ...apiResponse.data.data,
            follow_up_date: apiResponse.data.data.follow_up_date
              ? moment(
                  apiResponse.data.data.follow_up_date,
                  "DD-MM-YYYY HH:mm"
                ).format("DD-MM-YYYY HH:mm")
              : null,
          });

          formRefFollowUp.current.setFieldsValue({
            ...apiResponse.data.data,
            follow_up_date: apiResponse.data.data.follow_up_date
              ? moment(follow_up_date, "DD-MMMM-YYYY HH:mm")
              : null,
          });

          setapiloadingFollow(false);
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
          setapiloadingFollow(false);
        }
        // setapiloadingFollow(false);
      } catch (error) {
        setapiloadingFollow(false);
        setapiloadingFollow(false);
      }
    };
    if (companyDocumentId !== null) {
      getCompanyDocument();
    }
  }, [companyDocumentId, t]);

  //Fetch Company Document List
  useEffect(() => {
    const getCompanyDocumentList = async () => {
      // setBtnLoadingAdd(true);
      setapiloadingFollow(true);
      setCompanyDocumentList([]);
      try {
        let apiResponse = await getRequest(
          `request-for-demo-follow-up/?request_demo=${addedCompanyId}`,
          stateDocumentTable
        );
        if (apiResponse.data.results.success === true) {
          setCompanyDocumentList(apiResponse.data.results.data);

          settotalCount(apiResponse.data.count);
        }
        // setBtnLoadingAdd(false);
        setapiloadingFollow(false);
      } catch (error) {
        // setBtnLoadingAdd(false);
        setapiloadingFollow(false);
      }
    };
    if (addedCompanyId !== null) {
      getCompanyDocumentList();
    }
  }, [stateDocumentTable, reload, t, refreshGrid, addedCompanyId]);

  // Fetch Request Demo By Id
  useEffect(() => {
    const requesteddemoGetById = async () => {
      try {
        setapiLoading(true);
        setapiloadingFollow(true);
        const apiResponse = await getRequest(
          `request-demo/${requesteddemoId}/`
        );
        if (apiResponse.data.success) {
          setAddedCompanyId(apiResponse.data.data.id);
          setFollowUpCompanyName(apiResponse.data.data.company);
          const demoDate = apiResponse.data.data.demo_date
            ? moment(apiResponse.data.data.demo_date, "DD-MM-YYYY HH:mm")
            : null;
          const requestDate = apiResponse.data.data.request_date
            ? moment(apiResponse.data.data.request_date, "DD-MM-YYYY HH:mm")
            : null;
          setState({
            ...apiResponse.data.data,
            phone_number: apiResponse.data.data.phone_number,
            demo_type: apiResponse.data.data.demo_type,
            demo_date: apiResponse.data.data.demo_date
              ? moment(
                  apiResponse.data.data.demo_date,
                  "DD-MM-YYYY HH:mm"
                ).format("DD-MM-YYYY HH:mm")
              : null,
            request_date: apiResponse.data.data.request_date
              ? moment(
                  apiResponse.data.data.request_date,
                  "DD-MM-YYYY HH:mm"
                ).format("DD-MM-YYYY HH:mm")
              : null,
          });
          setFormSubmitted(true);
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            phone_number: apiResponse.data.data.phone_number,
            demo_date: demoDate ? moment(demoDate, "DD-MMMM-YYYY HH:mm") : null,
            request_date: requestDate
              ? moment(requestDate, "DD-MMMM-YYYY HH:mm")
              : null,
          });
          setapiLoading(false);
          setapiloadingFollow(false);
        }
      } catch (error) {
        setapiLoading(false);
        setapiloadingFollow(false);
      }
    };
    if (requesteddemoId !== null) {
      requesteddemoGetById();
    }
  }, [requesteddemoId, modalKey]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Handle Refresh Grid
  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };

  const columns = [
    {
      title: "Follow Up Date",
      dataIndex: "follow_up_date",
      key: "follow_up_date",
      sorter: true,
      width: 160,
    },
    {
      title: "Note",
      dataIndex: "follow_up_note",
      key: "follow_up_note",
      sorter: true,
      //   width: 150,
      render: (dataIndex) => (
        <Tooltip
          color={colors}
          placement="left"
          title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        >
          <div
            style={{
              width: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 30,
      render: (text, record) => (
        <Space>
          <Editicon
            onClick={() => handleEditIconClick(record.id)}
            style={{ cursor: "pointer" }}
          />
        </Space>
      ),
    },
  ];
  const disabledDate = (current) => {
    // Can not select days before today
    return current && current < dayjs().startOf("day");
  };

  // Handle Input Change
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleNoteChange = (name, e) => {
    setDocumentState({ ...documentState, [name]: e.target.value });
  };

  // Handle Option change
  const handleOptionChange = (fieldName, value) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value, // Use boolean directly
    }));
  };
  const handleDatepickerChangeFollowUp = (date, dateString, fieldName) => {
    const formattedDateString = dateString
      ? moment(dateString, "DD MMMM YYYY HH:mm").format("DD-MM-YYYY HH:mm")
      : null;

    setDocumentState({
      ...documentState,
      [fieldName]: formattedDateString ? formattedDateString : null,
    });
  };
  const handleDatepickerChange = (date, dateString, fieldName) => {
    const formattedDateString = dateString
      ? moment(dateString, "DD MMMM YYYY HH:mm").format("DD-MM-YYYY HH:mm")
      : null;

    setState({
      ...state,
      [fieldName]: formattedDateString ? formattedDateString : null,
    });
  };

  const disabledDateTime = (current) => {
    const now = dayjs();

    // Only disable time if selected date is today
    if (current && current.isSame(now, "day")) {
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(
            (hour) => hour < now.hour()
          ),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === now.hour()) {
            return Array.from({ length: 60 }, (_, i) => i).filter(
              (minute) => minute < now.minute()
            );
          }
          return [];
        },
      };
    }

    // For future dates, allow all time
    return {};
  };

  const phoneValidLength = state.phone_number;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }
    return Promise.resolve();
  };

  // Back To List
  const backToList = () => {
    setState(initialState);
    setFormSubmitted(false);
    setAddedCompanyId(null);
    setCompanyDocumentList(null);
    setButtonDisabled(false);
    setBtnDisplay("Add");
    formRef?.current?.setFieldsValue(initialState);
    setDocumentState(initialState);
    if (formSubmitted) {
      formRefFollowUp?.current?.setFieldsValue(initialDocument);
    }
    handleCancel();
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setStateDocumentTable({
      ...stateDocumentTable,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "follow_up_date" && sortOrder === "ascend") {
      sortingEnumKey = "follow_up_date";
    }
    if (sortField === "follow_up_date" && sortOrder === "descend") {
      sortingEnumKey = "-follow_up_date";
    }
    if (sortField === "follow_up_note" && sortOrder === "ascend") {
      sortingEnumKey = "follow_up_note";
    }
    if (sortField === "follow_up_note" && sortOrder === "descend") {
      sortingEnumKey = "-follow_up_note";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearchTable);
  };

  const onSearchTable = (value) => {
    setStateDocumentTable({
      ...stateDocumentTable,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleEditIconClick = (id) => {
    setapiLoading(true);
    setCompanyDocumentId(id);
    setBtnDisplay("Save");
  };

  // Fetch Form Submit
  const handleSubmit = async () => {
    console.log("statexs", state);

    const formattedState = {
      ...state,
      demo_date: dayjs(state.demo_date, "DD-MM-YYYY HH:mm").format(
        "DD-MM-YY HH:mm"
      ),
      request_date: dayjs(state.request_date, "DD-MM-YYYY HH:mm").format(
        "DD-MM-YY HH:mm"
      ),
    };


    try {
      setBtnLoading(true);
      let response;
      if (requesteddemoId === null) {
        response = await postRequest("request-demo/", formattedState);
      } else {
        response = await patchRequest(
          `request-demo/${requesteddemoId}/`,
          formattedState
        );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          requesteddemoId === null
            ? t("Demo request added successfully")
            : t("Demo request updated successfully")
        );
        setFormSubmitted(true);
        if (requesteddemoId === null) {
          setButtonDisabled(true);
          handleRefresh();
        }
        setAddedCompanyId(response.data.data.id);
        setBtnLoading(false);
        setReload((reload) => !reload);
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_updating_demo_list"));
      setBtnLoading(false);
    }
  };

  const handleCompanySubmit = async () => {

    if (!documentState.follow_up_date) {
      ErrorNotificationMsg(t("Please select date to proceed"));
      return;
    }

    const formattedPayload = {
      request_demo: addedCompanyId,
      follow_up_date: moment(
        documentState.follow_up_date,
        "DD-MM-YYYY HH:mm"
      ).format("DD-MM-YY HH:mm"),
      follow_up_note: documentState.follow_up_note,
    };

    try {
      setBtnLoadingAdd(true);
      let apiResponse;

      if (companyDocumentId === null) {
        apiResponse = await postRequest(
          "request-for-demo-follow-up/",
          formattedPayload
        );
      } else {
        apiResponse = await patchRequest(
          `request-for-demo-follow-up/${companyDocumentId}/`,
          formattedPayload
        );
      }

      if (apiResponse.data.success === true) {
        handleRefreshGrid();
        SuccessNotificationMsg(
          companyDocumentId === null
            ? t("Follow-up added successfully.")
            : t("Changes to the follow-up have been saved.")
        );
        setBtnDisplay("Add");
        setCompanyDocumentId(null);
        setDocumentState({ follow_up_date: null, follow_up_note: null });

        formRefFollowUp.current.setFieldsValue({
          follow_up_date: "",
          follow_up_note: "",
        });
      }
      setBtnLoadingAdd(false);
      handleCancel()
    } catch (error) {
      setBtnLoadingAdd(false);
    }
  };

  return (
    <>
      
      <Spin spinning={apiloadingFollow}>
      <Col className="TextFeild gutter-row">
        <h5 className="rfq-number new" style={{marginBottom: '10px'}}>
          Company : <span>{followUpCompanyName
          }</span>
        </h5>
      </Col>
        {formSubmitted && (
          <>
            <Form
              onFinish={handleCompanySubmit}
              autoComplete="off"
              ref={formRefFollowUp}
            >
              <Row gutter={[15]} style={{ marginBottom: "20px" }}>
                <Col xs={16} md={8} className="TextFeild gutter-row">
                  <Form.Item
                    name="follow_up_date"
                    label={t("pl_requested_demo_date_time4")}
                    rules={[
                      {
                        required: false,
                        message: <Trans>Please Select Demo Date</Trans>,
                      },
                    ]}
                  >
                    <Tooltip
                      color={colors}
                      style={{ color: "#fff" }}
                      placement="top"
                      title="Demo Request Date & Time"
                    >
                      <DatePicker
                        showTime={true}
                        showNow={false}
                        disabledDate={disabledDate}
                        disabledTime={disabledDateTime}
                        // format="YYYY-MM-DD hh:mm"
                        format="DD MMMM YYYY HH:mm"
                        value={
                          documentState?.follow_up_date
                            ? moment(
                                documentState?.follow_up_date,
                                "DD-MM-YYYY HH:mm"
                              )
                            : null
                        }
                        onChange={(date, dateString) =>
                          handleDatepickerChangeFollowUp(
                            date,
                            dateString,
                            "follow_up_date"
                          )
                        }
                      />
                    </Tooltip>
                  </Form.Item>
                </Col>
                <Col xs={20} md={10} className="TextFeild gutter-row">
                  <Form.Item
                    name={`follow_up_note`}
                    label={t("pl_note")}
                    rules={[
                      {
                        min: 3,
                        message: <Trans>{t("minlength_msg")}</Trans>,
                      },
                      {
                        max: 50,
                        message: <Trans>{t("maxlength_designation1")}</Trans>,
                      },
                    ]}
                  >
                    <TextArea
                      placeholder={t("place_note")}
                      value={documentState?.note}
                      onChange={(value) =>
                        handleNoteChange("follow_up_note", value)
                      }
                      autoSize={{ minRows: 1.5, maxRows: 2 }} // This will
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={20}
                  md={2}
                  className="gutter-row"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    paddingTop: "30px",
                    marginLeft: "20px",
                  }}
                >
                  {/* <Form.Item style={{ marginBottom: 0 }}> */}
                  <ButtonField
                    type="primary"
                    className="SaveGradiantBtn"
                    htmlType="submit"
                    label={t(btnDisplay)}
                    loading={btnLoadingAdd}
                  />
                  {/* </Form.Item> */}
                </Col>

                {/* <Col xs={4}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "10px",
                          }}
                        >
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn "
                            htmlType="Submit"
                            label={t(btnDisplay)}
                            loading={btnLoadingAdd}
                          />
                        </div>
                      </Col> */}
              </Row>
            </Form>
            <>
              <Table
                columns={columns}
                rowKey={(record) => record.id}
                dataSource={companyDocumentList}
                loading={apiloadingFollow}
                pagination={{
                  defaultCurrent: state.page,
                  defaultPageSize: state.pagesize,
                  total: totalCount,
                  showTotal: (total) => `Total ${total} items`,
                  showSizeChanger: true,
                  locale: {
                    items_per_page: "Items / Page",
                  },
                }}
                onChange={handleTableChange}
              />
            </>
          </>
        )}
      </Spin>
    </>
  );
};
RequestedFollowUpModal.propTypes = {
  requesteddemoId: PropTypes.number,
  setRequestedDemoId: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  setStateList: PropTypes.func,
  stateList: PropTypes.object,

  setReload: PropTypes.func,
  reload: PropTypes.bool,
  form: PropTypes.object,
  handleRefresh: PropTypes.func,
  modalKey: PropTypes.bool,
};

export default RequestedFollowUpModal;
